import { SWRConfig } from "swr";

import Bugsnag from "@bugsnag/js";
import type { GetServerSidePropsContext } from "next";

import EntityPageContainer from "components/EntityPageLayout";
import { entityLayoutData } from "components/EntityPageLayout/entityLayoutData";
import Page from "components/EntityPageLayout/EntityPagePeers";
import type { NextPageWithLayout } from "pages/_app";

const EntityPeersTabPage: NextPageWithLayout = () => {
  return <Page />;
};

export async function getServerSideProps(context: GetServerSidePropsContext) {
  try {
    const slug = context.params?.slug as string;

    const { entity, entityLayoutFallback } = await entityLayoutData(
      slug,
      context
    );

    if (!entity || entity.errors?.length) return { notFound: true };

    return {
      props: {
        slug,
        fallback: entityLayoutFallback,
      },
    };
  } catch (error: any) {
    console.error("[slug].tsx ~ getServerSideProps ~ error", error);
    Bugsnag.notify(error);
    return { notFound: true };
  }
}

EntityPeersTabPage.getLayout = (page, { pageProps }) => {
  const { fallback } = pageProps;

  return (
    <SWRConfig value={{ fallback }}>
      <EntityPageContainer hideRightPane {...pageProps}>
        {page}
      </EntityPageContainer>
    </SWRConfig>
  );
};

export default EntityPeersTabPage;
